import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Navigation from '../components/Navigation';
import { toast } from 'react-toastify';

function AddMember() {
  const [form, setForm] = useState({ name: '', phone: '', upiOrBank: '' });
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [terms, setTerms] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const res = await api.get('/Member/my-members');
      setMembers(res.data.members || []);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!terms) {
      toast.error('Please accept Terms & Conditions');
      return;
    }

    setLoading(true);
    try {
      const res = await api.post('/Member/add', {
        name: form.name,
        phone: form.phone,
        upiOrBank: form.upiOrBank || null,
      });

      toast.success(res.data.message || 'Member added!');
      setForm({ name: '', phone: '', upiOrBank: '' });
      setTerms(false);
      fetchMembers();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to add member');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 pb-20">
      <div className="bg-blue-600 text-white p-4">
        <button onClick={() => navigate(-1)} className="text-sm mb-2">← Back</button>
        <h2 className="text-xl font-bold">Add Member</h2>
      </div>

      <div className="p-4">
        {/* Add Form */}
        <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-4 shadow space-y-3">
          <input
            type="text"
            name="name"
            placeholder="Member Name"
            value={form.name}
            onChange={handleChange}
            required
            className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={form.phone}
            onChange={handleChange}
            required
            className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="text"
            name="upiOrBank"
            placeholder="UPI ID / Bank Details"
            value={form.upiOrBank}
            onChange={handleChange}
            className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <label className="flex items-center gap-2 text-sm text-gray-600">
            <input
              type="checkbox"
              checked={terms}
              onChange={(e) => setTerms(e.target.checked)}
            />
            I accept Terms & Conditions
          </label>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl disabled:opacity-50"
          >
            {loading ? 'Adding...' : 'Add Member'}
          </button>
        </form>

        {/* Members List */}
        <div className="mt-6">
          <h3 className="font-semibold text-gray-700 mb-3">
            My Members ({members.length})
          </h3>

          {members.length === 0 ? (
            <p className="text-center text-gray-400 py-6">No members added yet</p>
          ) : (
            <div className="space-y-2">
              {members.map((m) => (
                <div key={m.id} className="bg-white rounded-xl p-3 shadow flex justify-between items-center">
                  <div>
                    <p className="font-semibold">{m.name}</p>
                    <p className="text-sm text-gray-500">{m.phone}</p>
                  </div>
                  <span className={`text-xs px-2 py-1 rounded-full ${m.isActive ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
                    {m.isActive ? 'Active' : 'Inactive'}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <Navigation />
    </div>
  );
}

export default AddMember;